import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class FolderResolver  {
    constructor(private apiService: ApiServiceService) { }
   
    resolve(route: ActivatedRouteSnapshot) {
      return this.apiService.getWithTranslate('tree/translated/'+route.params['evaluationId'], route.params['folderId'])
        .then((data:any)=>{
          return data[0]
        })
    }
}
